<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M59.4133 56.1057L50.177 68.3052C49.4552 69.2582 48.3275 69.8192 47.1321 69.8192L31.6452 70.868C30.8501 70.9216 30.1199 71.3163 29.6378 71.9507L27.3513 74.9731C26.4124 76.2136 26.9255 78.0067 28.3775 78.5621L48.0061 86.073"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M29.4551 76.3151L45.1816 82.3344"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M48.0078 86.073L60.5625 102.927C61.4929 104.173 63.3565 104.182 64.2954 102.941L66.5819 99.919C67.0612 99.2846 67.2445 98.4727 67.0809 97.6945L63.8894 82.5037C63.5652 81.3534 63.7964 80.1156 64.5181 79.1627L94.8293 43.0379"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.3496 87.7477L62.4345 101.284"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.054 51.3805C92.054 51.3805 103.535 84.2545 105.043 90.4035C105.776 93.3865 99.4746 99.2874 94.5745 95.5799C90.8896 92.7916 81.2417 75.1394 76.6855 66.56"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M62.6707 81.5986C63.7336 57.1602 86.5452 -0.25091 103.994 15.2642C114.17 24.3116 92.4208 60.3433 48.9121 50.9942C-13.6106 37.5598 38.5368 26.8518 70.0434 36.2263"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M94.7188 53.6219L95.5392 52.5364C96.4837 51.2874 98.2627 51.0421 99.5117 51.9866L99.8416 52.2347C101.091 53.1792 101.336 54.9583 100.391 56.2072L97.29 60.3038"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M102.16 75.0153L102.981 73.9299C103.925 72.6809 105.704 72.4356 106.953 73.3801L107.283 73.6282C108.532 74.5727 108.777 76.3517 107.833 77.6007L104.731 81.6973"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M66.5666 32.313L67.3871 31.2275C68.3316 29.9785 68.0863 28.1995 66.8373 27.255L66.5074 27.0069C65.2584 26.0624 63.4794 26.3077 62.5349 27.5567L59.4336 31.6532"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M43.9553 30.954L44.7757 29.8686C45.7202 28.6196 45.475 26.8405 44.226 25.896L43.8961 25.6479C42.6471 24.7034 40.8681 24.9487 39.9236 26.1977L36.8223 30.2943"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M98.8233 19.8259L99.0094 19.9669C100.729 21.2666 101.592 23.2797 101.505 25.2814C103.092 23.119 102.655 20.074 100.509 18.4501L99.8806 17.9736C97.7351 16.3496 94.6845 16.7528 93.0352 18.8702C94.9382 18.2414 97.1063 18.529 98.8262 19.8287L98.8233 19.8259Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M89.5039 52.7592L99.7129 85.199"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.4169 71.2233L75.0156 73.0756"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.1102 75.9514L77.709 77.8037"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M81.8036 80.6795L80.4023 82.529"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.4969 85.4048L83.0957 87.2571"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M87.1903 90.1329L85.7891 91.9824"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M53.2079 53.6557L51.8066 55.5052"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M47.9266 52.3447L46.5254 54.197"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M42.6454 51.0365L41.2441 52.886"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M37.3661 49.7255L35.9648 51.5778"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M32.0848 48.4173L30.6836 50.2668"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M54.04 77.2257C52.8446 76.3207 51.1276 76.659 50.3663 77.9531L38.7251 97.7057C38.4939 98.0976 39.0183 98.4952 39.3341 98.1653L55.1847 81.6014"
            fill="white" />
        <path
            d="M54.04 77.2257C52.8446 76.3207 51.1276 76.659 50.3663 77.9531L38.7251 97.7057C38.4939 98.0976 39.0183 98.4952 39.3341 98.1653L55.1847 81.6014"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M50.4303 97.0798C50.4303 97.0798 39.2909 111.797 37.3652 115.355Z"
            fill="white" />
        <path
            d="M50.4303 97.0798C50.4303 97.0798 39.2909 111.797 37.3652 115.355"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.3772 100.348C52.3772 100.348 46.62 107.951 45.3203 109.668Z"
            fill="white" />
        <path
            d="M52.3772 100.348C52.3772 100.348 46.62 107.951 45.3203 109.668"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M37.3424 87.1725C37.3424 87.1725 26.203 101.89 24.2773 105.448Z"
            fill="white" />
        <path
            d="M37.3424 87.1725C37.3424 87.1725 26.203 101.89 24.2773 105.448"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M33.5862 86.1209C33.5862 86.1209 27.829 93.7248 26.5293 95.4418Z"
            fill="white" />
        <path
            d="M33.5862 86.1209C33.5862 86.1209 27.829 93.7248 26.5293 95.4418"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M34.0313 104.376C31.0822 108.259 26.997 113.745 26.9941 114.365Z"
            fill="white" />
        <path
            d="M34.0313 104.376C31.0822 108.259 26.997 113.745 26.9941 114.365"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.5231 71.1049C69.5006 71.0738 69.4752 71.0456 69.4442 71.0203C69.1622 70.7806 68.6717 70.899 68.3474 71.2797C68.0232 71.6603 67.9866 72.1649 68.2657 72.4046C68.2967 72.43 68.3277 72.4525 68.3615 72.4694L69.5231 71.1049Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M74.5798 65.0262C74.5572 64.9952 74.5318 64.967 74.5008 64.9417C74.2189 64.702 73.7283 64.8204 73.4041 65.201C73.0798 65.5817 73.0432 66.0863 73.3223 66.326C73.3533 66.3514 73.3843 66.3739 73.4182 66.3908L74.5798 65.0262Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.3591 59.3959C79.3365 59.3649 79.3111 59.3367 79.2801 59.3113C78.9982 59.0717 78.5076 59.1901 78.1834 59.5707C77.8591 59.9513 77.8225 60.456 78.1016 60.6957C78.1326 60.721 78.1636 60.7436 78.1975 60.7605L79.3591 59.3959Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.7673 53.2271C84.7447 53.1961 84.7193 53.1679 84.6883 53.1426C84.4064 52.9029 83.9158 53.0213 83.5916 53.4019C83.2673 53.7826 83.2307 54.2872 83.5098 54.5269C83.5408 54.5522 83.5718 54.5748 83.6057 54.5917L84.7673 53.2271Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M58.3145 60.1262C58.3398 60.1544 58.368 60.1826 58.399 60.2051C58.6979 60.4222 59.1772 60.27 59.4732 59.864C59.7693 59.458 59.7693 58.9533 59.4732 58.7362C59.4422 58.7137 59.4084 58.6939 59.3717 58.6798L58.3145 60.1262Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M53.375 66.6784C53.4004 66.7066 53.4286 66.7348 53.4596 66.7573C53.7584 66.9744 54.2377 66.8222 54.5338 66.4162C54.8298 66.0102 54.8298 65.5055 54.5338 65.2884C54.5027 65.2659 54.4689 65.2462 54.4323 65.2321L53.375 66.6784Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
